<div [cxFocus]="focusConfig" (esc)="dismiss('Escape clicked')" class="ff-mixed-cart-dialog">
  <div class="cx-modal-container">
    <div class="cx-modal-content ff-mixed-cart-dialog-container">
      <!-- Modal Header -->
      <ng-container>
        <div class="cx-dialog-header modal-header ff-mixed-cart-dialog-header">
          <!-- <div class="cx-dialog-title modal-title">
            {{ 'checkoutAddress.checkoutSplitPaymentDialog.title' | cxTranslate }}
          </div> -->
          <button type="button" class="close ff-mixed-cart-dialog-close" (click)="dismiss('Cross click')"
            attr.aria-label="{{ 'addToCart.closeModal' | cxTranslate }}">
            <img src="../../../../../../../assets/icons/close_black_24.svg">
          </button>
        </div>
        <!-- Separator -->
        <!-- <div class="cx-dialog-separator col-sm-12"></div> -->

        <!-- Modal Body -->
        <div class="modal-body ff-mixed-cart-dialog-body">
         
          <div class="cx-dialog-item">
            {{ 'checkoutAddress.ffMixedCartWarning' | cxTranslate }}
          </div>

          <div class="ff-mixed-cart-dialog-footer">
            <div class="cx-dialog-buttons">
              <button (click)="dismiss('cancel')" class="cx-btn btn btn-block btn-secondary mr-2">
                {{ 'common.cancel' | cxTranslate }}
              </button>
              <button (click)="dismiss('ok')" class="cx-btn btn btn-block btn-primary mt-0">
                {{ 'common.acknowledge' | cxTranslate }}
              </button>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>